import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"

import LinkWithIcon from "@/components/LinkWithIcon/LinkWithIcon"
import { Cell, Row } from "@/components/Table/Table"
import type { Ticket } from "@/types/ticketTypes"
import { linkIcon } from "@/utils/variables"

import style from "./TicketsStyle.module.css"

export default function TicketItem({
  ele,
  from,
}: {
  ele: Ticket
  from: number
}) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Row key={ele.id} className={"fw-medium"}>
      <Cell>{`${from}`}</Cell>
      <Cell>{ele.subject}</Cell>
      <Cell>
        <div>
          <p
            style={{
              width: "400px",
              maxWidth: "500px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {ele.description}
          </p>
        </div>
      </Cell>
      <Cell>
        <span
          className={`${style["status_btn"]} ${ele?.status == 0 ? style["pending"] : ele?.status == 1 ? style["opend"] : ele?.status == 2 ? style["progress"] : ele?.status == 3 && style["closed"]}`}
        >
          {ele?.status == 0
            ? t("ticketsPage.statuses.new")
            : ele?.status == 1
              ? t("ticketsPage.statuses.pending")
              : ele?.status == 2
                ? t("ticketsPage.statuses.inProgress")
                : ele?.status == 3 && t("ticketsPage.statuses.closed")}
        </span>
      </Cell>
      <Cell>
        <LinkWithIcon
          color={"#F15824"}
          title={t("ticketsPage.table.openTooltip")}
          icon={linkIcon}
          onClick={() => navigate(`chat/${ele.id}`)}
        />
      </Cell>
    </Row>
  )
}
